import { PickupType } from "../enum/pickup.type";

export class TimeItem {
    Time: Date;
    PickUpType: PickupType;
    IsShow: boolean = false;
    IsValid: boolean = true;
    IsValidReturn: boolean = true;
    EarliestTime: Date = new Date();
}